var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10470_10618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58169 0 0 3.58169 0 8C0 12.4183 3.58169 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58169 12.4183 0 8 0Z",
    fill: "#40B3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8938 4.60279L10.4649 11.807C10.4649 11.807 10.2651 12.3066 9.71556 12.0668L6.41818 9.53879L5.21918 8.95929L3.20081 8.27979C3.20081 8.27979 2.89106 8.16992 2.86106 7.9301C2.83112 7.69029 3.21081 7.56042 3.21081 7.56042L11.2343 4.41292C11.2343 4.41292 11.8938 4.12317 11.8938 4.60279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16431 11.7245C6.16431 11.7245 6.06806 11.7155 5.94812 11.3358C5.82825 10.9561 5.21875 8.95769 5.21875 8.95769L10.0648 5.88019C10.0648 5.88019 10.3446 5.71031 10.3346 5.88019C10.3346 5.88019 10.3846 5.91013 10.2347 6.05C10.0848 6.18994 6.42775 9.47725 6.42775 9.47725",
    fill: "#D2E5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68181 10.5064L6.37756 11.6956C6.37756 11.6956 6.27562 11.7729 6.16406 11.7244L6.41381 9.51562",
    fill: "#B5CFE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10470_10618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "res/media/telegram.07cf30f33174a143f2c5e02cbfe6acbc.svg";
export { ForwardRef as ReactComponent };